module.exports = __webpack_public_path__ + "static/media/18ECA17.d8a2f992.jpg";